/* import React, { useEffect } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router';
import { useWalletContext } from 'src/components/walletcontexthook';


const WalletAmount = () => {
  const navigate = useNavigate();
  const { walletAmount, fetchOperatorDetails } = useWalletContext();

  const operatortypeAccount = localStorage.getItem('operatorData')
  const opeartoraccountconvert = JSON.parse(operatortypeAccount)
  const accountType = localStorage.getItem('accountType');

  useEffect(() => {
    fetchOperatorDetails();
  }, [fetchOperatorDetails]);

  return (
    <Tooltip arrow title="Wallet Amount">
      <IconButton
        color="primary"
        onClick={() => navigate('/ottfranchisepayments/payments')}
        sx={{
          backgroundColor: 'rgba(40, 45, 71, 0.5)',
          border: '1px solid #FFFFFF',
          borderRadius: '8px',
          padding: '6px 12px',
          gap: 0.5
        }}
      >
        <AccountBalanceWalletIcon />
        <CurrencyRupeeIcon />
        <Typography sx={{ fontSize: '20px' }}>
         
          {accountType !== 'OWNER' && walletAmount}
        </Typography>
      </IconButton>
    </Tooltip>
  );
};

export default WalletAmount;
 */

  import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Tooltip,
  Typography,
  Popover,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router';
import { useWalletContext } from 'src/components/walletcontexthook';

const WalletAmount = () => {
  const navigate = useNavigate();
  const { walletAmount, fetchOperatorDetails } = useWalletContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const accountType = localStorage.getItem('accountType');

  useEffect(() => {
    fetchOperatorDetails();
  }, [fetchOperatorDetails]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isMobile) {
      setAnchorEl(event.currentTarget); // 📱 open popup
    } else {
      navigate('/ottfranchisepayments/payments'); // 💻 navigate
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip arrow title="Wallet">
        <IconButton
          color="primary"
          onClick={handleClick}
          sx={{
            backgroundColor: 'rgba(40, 45, 71, 0.5)',
            border: '1px solid #FFFFFF',
            borderRadius: '8px',
            px: isMobile ? 1 : 1.5,
            py: isMobile ? 1 : 0.8,
            gap: isMobile ? 0 : 0.5
          }}
        >
          <AccountBalanceWalletIcon />

          {/* 💻 Desktop */}
          {!isMobile && (
            <>
              <CurrencyRupeeIcon />
              <Typography sx={{ fontSize: '16px' }}>
                {accountType !== 'OWNER' && walletAmount}
              </Typography>
            </>
          )}
        </IconButton>
      </Tooltip>

      {/* 📱 MOBILE POPUP */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: '12px',
            background: '#0b1a3a',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }
        }}
      >
        <CurrencyRupeeIcon />
        <Typography fontWeight={600}>
          {walletAmount}
        </Typography>
      </Popover>
    </>
  );
};

export default WalletAmount;